export default {
  首页: "Početna",
  资产: "Imovina",
  币币: "Spot",
  快捷买币: "Brza kupnja kriptovaluta",
  "支持多种方式购买，购买更简单":
    "Kupujte jednostavno putem više načina plaćanja",
  语言设置: "Postavke jezika",
  确认恢复: "Potvrdi oporavak",
  "输入邮箱，方便我们联系您":
    "Unesite svoju e-adresu kako bismo vas mogli kontaktirati",
  划转: "Prenos",
  行情: "Tržište",
  "24H成交": "Volumen 24h",
  累计收益: "Ukupni prinos",
  充值时间: "Datum uplate",
  到期时间: "Datum isteka",
  数量: "Količina",
  操作: "Radnja",
  资产信息: "Informacije o imovini",
  复制地址: "Kopiraj adresu",
  链名称: "Naziv blockchaina",
  充值地址: "Adresa za uplatu",
  收款地址: "Adresa za primanje",
  账单: "Račun",
  提现金额: "Iznos za isplatu",
  接收地址: "Adresa za primanje",
  交易密码: "Lozinka za trgovanje",
  提现全部: "Isplati sve",
  保存图片: "Spremi sliku",
  输入您的交易密码: "Unesite svoju lozinku za trgovanje",
  确定: "Potvrdi",
  地址: "Adresa",
  注册时间: "Datum registracije",
  取消: "Odustani",
  是否划转: "Prenos?",
  登录: "Prijava",
  我的地址: "Moje adrese",
  登录密码和交易密码: "Lozinka za prijavu i lozinka za trgovanje",
  注册: "Registracija",
  密码: "Lozinka",
  设置密码: "Postavi lozinku",
  重复密码: "Ponovi lozinku",
  新密码: "Nova lozinka",
  确认新密码: "Potvrdi novu lozinku",
  充值: "Uplata",
  充值货币: "Uplata valute",
  合约账户充值: "Uplata na račun terminskih ugovora",
  账户充值: "Uplata na račun",
  其他: "Ostalo",
  我的邀请码: "Moj pozivni kod",
  提现: "Isplata",
  客服: "Korisnička podrška",
  持有详情: "Detalji posjeda",
  请输入内容: "Unesite sadržaj",
  邀请好友来领取奖励: "Pozovite prijatelje i osvojite nagrade",
  复制链接: "Kopiraj poveznicu",
  重复设置新的密码: "Ponovi novu lozinku",
  保存: "Spremi",
  我的: "Moj račun",
  "邮箱/手机号": "E-adresa/Broj mobitela",
  备注: "Napomena",
  地址管理: "Upravljanje adresama",
  我的团队: "Moj tim",
  联系我们: "Kontaktirajte nas",
  竭诚为您服务: "Stojimo vam na raspolaganju",
  提取收益: "Povlačenje prinosa",
  带给我的收益: "Generirani prinos",
  添加: "Dodaj",
  名称: "Ime",
  添加地址: "Dodaj adresu",
  修改地址: "Izmijeni adresu",
  可提现: "Isplativo",
  安全中心: "Sigurnosni centar",
  收益划转: "Prenos prinosa",
  通知中心: "Obavijesti",
  "累计收益:": "Ukupni prinos:",
  注册用户: "Registrirani korisnici",
  奖励规则: "Pravila nagrađivanja",
  帮助反馈: "Pomoć i povratne informacije",
  邀请好友: "Pozovi prijatelje",
  恢复身份: "Oporavak identiteta",
  选择语言: "Odabir jezika",
  设置新的密码: "Postavi novu lozinku",
  暂无活动: "Nema aktivnih aktivnosti",
  "月增长量(+)": "Mjesečni rast (+)",
  可提取: "Isplativo",
  反馈类型: "Vrsta povratne informacije",
  赠送: "Poklon",
  已经复制: "Kopirano",
  保存成功: "Uspješno spremljeno",
  划转成功: "Uspješan prenos",
  过期: "Isteklo",
  提交成功: "Uspješno poslano",
  "服务器繁忙，稍后在试": "Poslužitelj je zauzet, pokušajte ponovo kasnije",
  全部: "Sve",
  一级: "Razina 1",
  二级: "Razina 2",
  三级: "Razina 3",
  级: "Razina",
  删除成功: "Uspješno izbrisano",
  选择地址: "Odabir adrese",
  不再提醒: "Ne prikazuj više",
  "最小充值金额：": "Minimalni iznos uplate:",
  选择币种: "Odabir kriptovalute",
  输入投资金额: "Unesite iznos ulaganja",
  输入账户密码: "Unesite lozinku računa",
  投资: "Ulaganje",
  订单编号: "Broj narudžbe",
  投资周期: "Razdoblje ulaganja",
  投资资金: "Uloženi iznos",
  投资时间: "Vrijeme ulaganja",
  状态: "Status",
  投资中: "Aktivno",
  已到期: "Isteklo",
  暂无数据: "Nema podataka",
  转入: "Prenos na",
  邮箱: "E-adresa",
  请输入邮箱: "Unesite e-adresu",
  请输入格式正确的邮箱: "Unesite ispravnu e-adresu",
  请输入验证码: "Unesite verifikacijski kod",
  获取验证码: "Dobij verifikacijski kod",
  请输入邀请码: "Unesite pozivni kod",
  今天: "Danas",
  昨天: "Jučer",
  最近七天: "Zadnjih 7 dana",
  邀请: "Poziv",
  购买数量: "Količina za kupnju",
  产品详情: "Detalji proizvoda",
  币种: "Kriptovaluta",
  利息币种: "Valuta prinosa",
  理财类型: "Vrsta financijskog proizvoda",
  产品费率: "Naknade proizvoda",
  进行中: "Aktivno",
  每天: "Dnevno",
  请输入搜索关键词: "Unesite pojam za pretraživanje",
  通知: "Obavijesti",
  查看更多: "Pogledaj više",
  理财宝: "Financijski proizvodi",
  周期: "Rok",
  年利率: "Godišnja kamatna stopa (APY)",
  更多产品: "Više proizvoda",
  灵活存取: "Fleksibilna štednja",
  稳定收益: "Stabilan prinos",
  合约指南: "Vodič za terminske ugovore",
  资金划转出: "Odlazni prijenos",
  矿池收益: "Nagrada za rudarenje",
  提现手续费: "Naknada za isplatu",
  冻结资金: "Zamrznuta sredstva",
  解冻资金: "Odmrzavanje zamrznutih sredstava",
  闪兑支出: "Trošak brze zamjene",
  闪兑收入: "Prihod od brze zamjene",
  闪兑手续费: "Naknada za brzu zamjenu",
  合约支出: "Trošak terminskih ugovora",
  合约收入: "Prihod od terminskih ugovora",
  输入的金额不可大于可用金额: "Iznos ne može biti veći od raspoloživog iznosa",
  全部兑换成功: "Uspješna potpuna zamjena",
  返回: "Natrag",
  查看历史: "Pogledaj povijest",
  闪兑历史: "Povijest brze zamjene",
  支付: "Plaćanje",
  获取: "Dobij",
  时间: "Vrijeme",
  手续费: "Naknada za transakciju",
  折扣: "Popust",
  价格: "Cijena",
  逐仓: "Izolirani margin",
  全仓: "Unakrsni margin",
  市价委托: "Tržišni nalog",
  限价委托: "Limitirani nalog",
  请输入本金: "Unesite glavnicu",
  请输入价格: "Unesite cijenu",
  "可做空/做多": "Moguće otvaranje Short/Long pozicije",
  设置止盈止损: "Postavi ograničenje dobiti/zaustavljanje gubitka",
  止盈价: "Cijena ograničenja dobiti",
  止损价: "Cijena zaustavljanja gubitka",
  成本: "Troškovna cijena",
  做多: "Long (Kupnja)",
  做空: "Short (Prodaja)",
  仓位信息: "Informacije o poziciji",
  一键平仓: "Zatvori poziciju (jedan klik)",
  永续: "Perpetual",
  浮动盈亏: "Nerealizirana dobit/gubitak",
  平仓: "Zatvori poziciju",
  反向开仓: "Otvori obrnutu poziciju",
  一键撤销: "Otkaži sve (jedan klik)",
  倍杠杆: "x poluga",
  执行价格: "Cijena izvršenja",
  委托数量: "Količina naloga",
  保证金: "Margina",
  成交价: "Cijena izvršenja",
  创建时间: "Vrijeme stvaranja",
  撤销: "Otkaži",
  合约市场: "Tržište terminskih ugovora",
  交易方向: "Smjer trgovanja",
  委托价格: "Cijena naloga",
  委托金额: "Iznos naloga",
  资金费率: "Stopa financiranja",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Periodična naknada koju plaćaju long i short pozicije, obračunava se svakih 8 sati.",
  "资金费率为正，多方向空方支付资金费用。":
    "Uz pozitivnu stopu financiranja, long pozicije plaćaju short pozicijama.",
  "资金费率为负，空方向多方支付资金费用。":
    "Uz negativnu stopu financiranja, short pozicije plaćaju long pozicijama.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Jeste li sigurni da želite otvoriti obrnutu poziciju? Ovo će kupiti suprotnu poziciju od vaše trenutne.",
  "仓位止盈/止损": "Ograničenje dobiti/zaustavljanje gubitka za poziciju",
  合约名称: "Terminski ugovor",
  开仓价格: "Cijena otvaranja",
  指数价格: "Cijena indeksa",
  止盈设置: "Postavke ograničenja dobiti",
  请输入止盈价: "Unesite cijenu ograničenja dobiti",
  "当指数价格触达*时，将会触发委托平仓":
    "Kada cijena indeksa dosegne *, aktivirat će se nalog za zatvaranje.",
  预计盈亏: "Očekivana dobit/gubitak",
  当前仓位: "Trenutna pozicija",
  平仓金额: "Iznos zatvaranja",
  仓位模式: "Način rada pozicije",
  全仓模式: "Način unakrsnog margina",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "U načinu unakrsnog margina, sva raspoloživa sredstva na vašem računu terminskih ugovora koriste se kao margina. Likvidacija se događa kada gubitak premaši vaš ukupni saldo, što rezultira gubitkom cijele vaše margine i pozicije.",
  逐仓模式: "Način izoliranog margina",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Određeni iznos margine dodjeljuje se poziciji. Ako gubitak margine padne ispod razine margine održavanja, pozicija se likvidira. Možete povećati ili smanjiti marginu za ovu poziciju.",
  "是否撤销？": "Otkaži nalog?",
  "是否一键撤销？": "Otkaži sve naloge?",
  "是否一键平仓？": "Zatvori sve pozicije?",
  持仓保证金: "Margina trenutne pozicije",
  风险率: "Postotak rizika",
  未实现盈亏: "Nerealizirana dobit/gubitak",
  可用保证金: "Raspoloživa margina",
  净值: "Neto vrijednost",
  账户余额: "Stanje računa",
  合约计算器: "Kalkulator terminskih ugovora",
  交易记录: "Povijest transakcija",
  "*倍杠杆": "*x poluga",
  "平仓盈亏：": "Realizirana dobit/gubitak:",
  时间筛选: "Filtar vremena",
  仓位类型: "Vrsta pozicije",
  订单状态: "Status narudžbe",
  订单类型: "Vrsta naloga",
  平仓价格: "Cijena zatvaranja",
  持仓数量: "Količina pozicije",
  "手续费(%)": "Naknada za transakciju (%)",
  平仓时间: "Vrijeme zatvaranja",
  平仓类型: "Vrsta zatvaranja",
  手动平仓: "Ručno zatvaranje",
  强制平仓: "Prisilna likvidacija",
  近1天: "Zadnji dan",
  近7天: "Zadnjih 7 dana",
  近30天: "Zadnjih 30 dana",
  近180天: "Zadnjih 180 dana",
  持仓: "Otvorena pozicija",
  已取消: "Otkazano",
  分时: "Unutardnevno",
  "24H额(USDT)": "Volumen 24h (USDT)",
  "24H低": "Najniža 24h",
  "24H量(BTC)": "Volumen 24h (BTC)",
  "24H高": "Najviša 24h",
  "10秒": "10 sekundi",
  "30秒": "30 sekundi",
  "1分": "1 minuta",
  "3分": "3 minute",
  "5分": "5 minuta",
  "30分": "30 minuta",
  "1小时": "1 sat",
  "4小时": "4 sata",
  "8小时": "8 sati",
  "1天": "1 dan",
  "1周": "1 tjedan",
  "1月": "1 mjesec",
  单向持仓: "Jednosmjerna pozicija",
  杠杆: "Poluga",
  仓位: "Pozicija",
  计算结果: "Rezultat",
  盈亏: "Dobit/Gubitak",
  收益率: "Prinos",
  计算结果仅供参考: "Rezultat je indikativan",
  成交后仓位大小: "Veličina pozicije nakon izvršenja",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Rezultat je indikativan, stvarni rezultati mogu varirati zbog naknada.",
  目标价格: "Ciljna cijena",
  开始计算: "Izračunaj",
  强平价格: "Cijena likvidacije",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Pažljivo provjerite naziv blockchaina prije uplate. Neispravne uplate ne mogu se poništiti. Minimalni iznos uplate je *. Uplate ispod ovog iznosa neće biti obrađene. Ne šaljite drugu imovinu na ovu adresu. Nemojte koristiti ICO ili adrese za financiranje za isplate.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Minimalna količina za isplatu je *. Naknade za isplatu bit će odbijene od iznosa isplate. Pažljivo provjerite adresu primatelja. Ne šaljite * na adrese izvan *. Nemojte koristiti ICO ili adrese za financiranje.",
  退出登录: "Odjava",
  加仓: "Povećanje pozicije",
  新增仓位: "Nova pozicija",
  输入加仓金额: "Unesite iznos za povećanje pozicije",
  "当前可用:": "Trenutno raspoloživo:",
  资产账单: "Račun imovine",
  保存二维码: "Spremi QR kod",
  温馨提示: "Napomena",
  "请注意：您当前使用的网络": "Napomena: Trenutno koristite mrežu",
  输入提现地址: "Unesite adresu za isplatu",
  "可用金额：": "Raspoloživi iznos:",
  输入资产密码: "Unesite lozinku za imovinu",
  可用手续费: "Raspoloživa naknada",
  "折扣%": "Popust %",
  实扣手续费: "Stvarno naplaćena naknada",
  实际到账: "Stvarno primljeni iznos",
  未设置资产密码: "Nije postavljena lozinka za imovinu",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Radi vaše sigurnosti, postavite lozinku za imovinu prije nego što izvršite isplatu.",
  热榜: "Popularno",
  涨幅榜: "Najveći rast",
  跌幅榜: "Najveći pad",
  成交额榜: "Ljestvica volumena",
  关于我们: "O nama",
  登录密码: "Lozinka za prijavu",
  设置: "Postavke",
  资产密码: "Lozinka za imovinu",
  修改登录密码: "Izmijeni lozinku za prijavu",
  原密码: "Stara lozinka",
  请输入新密码: "Unesite novu lozinku",
  请输入原密码: "Unesite staru lozinku",
  确认密码: "Potvrdi lozinku",
  确定修改: "Potvrdi izmjenu",
  修改资产密码: "Izmijeni lozinku za imovinu",
  验证码: "Verifikacijski kod",
  资产密码使用提示: "Savjeti za lozinku imovine",
  "资产密码用于转移、提取资产和交易。":
    "Lozinka za imovinu koristi se za prijenos, isplatu i trgovanje imovinom.",
  "创建与登录密码不同的资产密码。":
    "Stvorite lozinku za imovinu različitu od lozinke za prijavu.",
  "定期更改您的资产密码。": "Redovito mijenjajte svoju lozinku za imovinu.",
  提币历史: "Povijest isplata",
  "金额/余额": "Iznos/Stanje",
  "手续费/折扣": "Naknada/Popust",
  自选: "Favoriti",
  现货: "Spot",
  市价: "Tržišna cijena",
  止损设置: "Postavke zaustavljanja gubitka",
  合约K线图: "Grafikon terminskih ugovora",
  "24H量": "Volumen 24h",
  "24H额": "Volumen 24h (USDT)",
  合作指南: "Vodič za partnere",
  盈亏计算: "Izračun dobiti/gubitka",
  当前可用: "Trenutno raspoloživo",
  请输入加仓金额: "Unesite iznos za povećanje pozicije",
  请重新输入加仓金额: "Ponovno unesite iznos za povećanje pozicije",
  平仓数量: "Količina za zatvaranje",
  欢迎登录: "Dobrodošli natrag",
  "忘记密码?": "Zaboravili ste lozinku?",
  "还没有账号？": "Još nemate račun?",
  立即注册: "Registrirajte se odmah",
  繁體中文: "Tradicionalni kineski",
  找回密码: "Oporavak lozinke",
  下一步: "Sljedeće",
  注册账户: "Registracija računa",
  "请输入邀请码(选填)": "Unesite pozivni kod (opcionalno)",
  谢邀豪礼: "Pozivni bonus",
  "24小时邀请好友排名": "24h ljestvica poziva",
  "*人": "* osoba",
  "差*人": "Nedostaje * osoba",
  "已超过10万人，每月轻松赚钱":
    "Više od 100.000 korisnika, lako zarađujte svaki mjesec",
  最高: "Maksimalno",
  邀请链接: "Poveznica za poziv",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Dijelite naknade za transakcije koje generiraju vaši prijatelji (spot, terminski ugovori, margina, brza zamjena).",
  平台和您一起分享手续费: "Dijelite naknade za transakcije s platformom",
  "*级": "* razina",
  规则: "Pravila",
  我的好友: "Moji prijatelji",
  好友详情: "Detalji prijatelja",
  获得好友佣金方案: "Plan provizije za prijatelje",
  我的等级: "Moja razina",
  我的邀请数据: "Moji podaci o pozivima",
  当前等级: "Trenutna razina",
  平台奖励您: "Nagrada platforme za vas",
  最高可获取平台奖励: "Maksimalna nagrada platforme",
  邀请规则: "Pravila pozivanja",
  "邀请*级有效好友": "Pozovite aktivne prijatelje razine *",
  好友等级: "Razina prijatelja",
  人: "osobe",
  奖金派送: "Isplata bonusa",
  平台奖励: "Nagrada platforme",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Platforma zadržava pravo konačnog tumačenja. U slučaju prijevarnih aktivnosti, nagrade će biti oduzete i vaš račun će biti zamrznut. Izgubljena imovina ne može se povratiti.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Vaš račun mora biti aktivan, definiran kao uplata vrijednosti od najmanje * USDT u bilo kojoj kriptovaluti.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Vaš pozvani prijatelj mora biti aktivna niža razina, definirana kao uplata vrijednosti od najmanje * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Pozivatelj i pozvani ne smiju dijeliti istu IP adresu.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP razina određena je brojem pozvanih prijatelja razine *.",
  佣金成分: "Komponente provizije",
  收益统计: "Statistika prinosa",
  昨日收益: "Jučerašnji prinos",
  月收益: "Mjesečni prinos",
  获取收益: "Dobij prinos",
  "总收益：": "Ukupni prinos:",
  "*级好友": "Prijatelji razine *",
  理财购买: "Kupnja financijskog proizvoda",
  期限: "Rok",
  可用金额: "Raspoloživi iznos",
  预估收益: "Procijenjeni prinos",
  申购上限: "Maksimalna kupnja",
  项目剩余: "Preostalo projekta",
  "买入后预计*(SGT)开始计算收益。":
    "Prinos će početi teći približno u *(SGT) nakon kupnje.",
  计息日: "Početak obračuna kamata",
  申购日: "Datum kupnje",
  到账日: "Datum odobrenja",
  到期自动续投: "Automatsko ponovno ulaganje po isteku",
  申购: "Kupi",
  搜索理财项目: "Pretraži financijski proizvod",
  超高年化随心选: "Odaberite među proizvodima visokog prinosa",
  "自由选择理财币种，稳定超额收益":
    "Slobodno birajte svoju kriptovalutu za stabilne, iznadprosječne prinose",
  理财总资产: "Ukupna uložena imovina",
  申购数量: "Količina za kupnju",
  立即购买: "Kupi odmah",
  年化收益率: "Godišnji postotak prinosa (APY)",
  理财订单: "Narudžbe financijskih proizvoda",
  持有: "U posjedu",
  申购份额: "Kupljeni udio",
  到账日期: "Datum odobrenja",
  申购成功: "Uspješna kupnja",
  到期: "Isteklo",
  是否选择做多: "Otvori Long poziciju?",
  "可用余额为0 不能操作": "Stanje je 0, radnja nije moguća",
  福利中心: "Centar bonusa",
  奖励记录: "Povijest nagrada",
  我获取到的奖励: "Moje osvojene nagrade",
  总价值: "Ukupna vrijednost",
  新手任务: "Zadaci za nove korisnike",
  身份认证: "Verifikacija identiteta (KYC)",
  身份验证: "Verifikacija identiteta",
  去验证: "Verificiraj se odmah",
  审核中: "Na čekanju",
  已验证: "Verificirano",
  认证失败: "Verifikacija neuspješna",
  基础认证: "Osnovna verifikacija",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Napomena: Verificirane informacije ne mogu se mijenjati. Unesite točne podatke.",
  "国家/地区": "Država/Regija",
  请选择: "Odaberi",
  证件类型: "Vrsta dokumenta",
  证件编码: "Broj dokumenta",
  身份证: "Osobna iskaznica",
  护照: "Putovnica",
  驾驶证: "Vozačka dozvola",
  请输入编码: "Unesite broj",
  名字: "Ime",
  请输入: "Unesite",
  中间名: "Srednje ime",
  选填: "Opcionalno",
  姓氏: "Prezime",
  中国: "Kina",
  身份上传: "Prijenos dokumenta identiteta",
  上传身份证: "Prijenos osobne iskaznice",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Prenesite u JPG/JPEG/PNG formatu. Provjerite jesu li slike jasne, potpune i ravnomjerno osvijetljene. Maksimalno *MB.",
  确定提交: "Pošalji",
  去认证: "Verificiraj",
  挑战任务: "Izazovni zadaci",
  注册认证任务: "Zadatak registracije i verifikacije",
  完成注册认证即可领取: "Dovršite registraciju i verifikaciju za primanje",
  领取奖励: "Preuzmi nagradu",
  新人豪礼: "Dobrodošli bonus",
  "参与人数：": "Broj sudionika:",
  条件: "Uvjet",
  入金量: "Iznos uplate",
  完成: "Dovršeno",
  任务奖励: "Nagrada za zadatak",
  距任务更新: "Do ažuriranja zadatka",
  "条件：": "Uvjet:",
  活动规则: "Pravila aktivnosti",
  奖励明细: "Detalji nagrade",
  已获得: "Osvojeno",
  交易奖励: "Nagrada za trgovanje",
  Win奖励: "WIN nagrada",
  已领取: "Preuzeto",
  亏损金额超过: "Iznos gubitka prelazi",
  单笔开仓金额超过: "Iznos pojedinačnog naloga prelazi",
  交易量: "Volumen trgovanja",
  待完成: "Za dovršiti",
  入金: "Uplata",
  盈利金额超过: "Iznos dobiti prelazi",
  开仓金额: "Iznos naloga",
  开仓金: "Iznos naloga",
  盈利: "Dobit",
  亏损: "Gubitak",
  领取: "Preuzmi",
  未领取: "Nije preuzeto",
  待领取: "Za preuzeti",
  再交易: "Trgujte dalje",
  即可获得: "da biste dobili",
  领取成功: "Uspješno preuzeto",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Sve aktivnosti obračunavat će se na datum završetka. Nagrade istječu nakon toga.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Zarađeni prinos bit će odobren na vaš račun za nagrade, koji možete zamijeniti ili isplatiti u bilo kojem trenutku.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Kriptovaluta nagrade ovisi o zadatku.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Platforma zadržava pravo konačnog tumačenja. U slučaju prijevare u zadacima, nagrade će biti zadržane i vaš račun može biti zamrznut.",
  成长学院: "Akademija",
  "区块链 & 加密货币": "Blockchain & Kriptovalute",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Vaš potpuni vodič za kriptovalute. Pratimo vas na vašem kripto putovanju.",
  "全仓合约定单的全部保证金。":
    "Ukupna margina za naloge terminskih ugovora s unakrsnim marginom.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Stanje + (nerealizirana dobit/gubitak - naknade - kamate financiranja) = Neto vrijednost / Iskorištena margina * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Nerealizirana dobit/gubitak izravno utječe na 'raspoloživu marginu'. Ako nerealizirana dobit/gubitak raste, raspoloživa margina raste i obrnuto.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Stanje - (Iskorištena margina) + (nerealizirana dobit/gubitak - naknade - kamate financiranja)",
  "注:可继续用于开仓的保证金。":
    "Napomena: Margina koja je dostupna za otvaranje novih pozicija.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Stanje + (nerealizirana dobit/gubitak - naknade - kamate financiranja)",
  "注:当前的资金结余。": "Napomena: Trenutno stanje.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Odnosi se na ukupno stanje računa terminskih ugovora, uključujući zamrznute iznose.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Napomena: Što je veći postotak rizika, to je niži rizik i obrnuto.",
  该功能尚未开发: "Ova je funkcija još u razvoju",
  重置密码: "Resetiranje lozinke",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Unesite 8-20 znakova, uključujući slova, brojeve i posebne znakove",
  修改成功: "Uspješna izmjena",
  输入验证码: "Unesite verifikacijski kod",
  输入密码: "Unesite lozinku",
  详情说明: "Detalji",
  已售罄: "Rasprodano",
  剩余期限: "Preostali rok",
  限期: "Rok",
  闪兑货币选择: "Odabir valute za brzu zamjenu",
  地区选择: "Odabir regije",
  "搜索国家/地区": "Pretraži državu/regiju",
  "身份信息已提交，将在*小时内审核完成":
    "Podaci o identitetu poslani. Obrada će trajati do * sati.",
  "选择国家/地区": "Odabir države/regije",
  "止盈价格需高于*": "Cijena ograničenja dobiti mora biti viša od *",
  "止损价格需低于*": "Cijena zaustavljanja gubitka mora biti niža od *",
  "止盈价格需低于*": "Cijena ograničenja dobiti mora biti niža od *",
  "止损价格需高于*": "Cijena zaustavljanja gubitka mora biti viša od *",
  教程详情: "Detalji vodiča",
  请输入止损价: "Unesite cijenu zaustavljanja gubitka",
  活期: "Fleksibilno",
  赎回后立即到账: "Trenutno odobrenje nakon otkupa",
  赎回: "Otkup",
  赎回理财: "Otkup financijskog proizvoda",
  是否赎回当前的理财订单: "Otkupiti trenutnu narudžbu financijskog proizvoda?",
  维护: "Održavanje",
  "系统正在维护中……": "Sustav je u održavanju...",
  合约: "Terminski ugovori",
  闪电兑换: "Brza zamjena",
  流水挖矿: "Rudarenje volumena",
  邀请豪礼: "Pozivni bonus",
  计算器: "Kalkulator",
  最新价: "Posljednja cijena",
  涨跌幅: "Promjena (24h)",
  关注币种添加自选: "Dodaj kriptovalutu u favorite",
  一键添加自选: "Dodaj u favorite (jedan klik)",
  全标已读: "Označi sve kao pročitano",
  无消息: "Nema poruka",
  "暂时还没有收到任何消息通知哦!": "Još niste primili nikakve obavijesti!",
  没有更多数据: "Nema daljnjih podataka",
  闪兑: "Brza zamjena",
  从: "Od",
  "可用余额：": "Raspoloživo stanje:",
  至: "Do",
  预览兑换结果: "Pregled rezultata zamjene",
  闪兑规则: "Pravila brze zamjene",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Brza zamjena podložna je tržišnim fluktuacijama. Stvarno primljeni iznos je mjerodavan.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Tečajeve određuju treće strane. Zbog troškova i fluktuacija, tečaj se može razlikovati od tržišnog tečaja. Pažljivo provjerite.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Platforma naplaćuje približno *% naknade po zamjeni za pokrivanje troškova na burzama.",
  确认汇兑: "Potvrdi zamjenu",
  您预估得到: "Procijenjena dobit",
  汇兑: "Zamjena",
  汇兑比例: "Tečaj",
  刷新: "Osvježi",
  兑换: "Zamijeni",
  没有更多了: "Nema daljnjih podataka",
  搜索币种: "Pretraži kriptovalutu",
  可用: "Raspoloživo",
  我知道了: "Razumijem",
  最新价格: "Posljednja cijena",
  确认: "Potvrdi",
  最大: "Maksimalno",
  "风险率(%)": "Postotak rizika (%)",
  当前委托: "Trenutni nalozi",
  合作交易历史记录: "Povijest transakcija partnera",
  重置: "Resetiraj",
  余额: "Stanje",
  现货账户: "Spot račun",
  合约账户: "Račun terminskih ugovora",
  WIN账户: "WIN račun",
  赏金账户: "Račun za nagrade",
  总资产折合: "Ukupna imovina (u USDT)",
  今日收益: "Današnji prinos",
  充币: "Uplata",
  提币: "Isplata",
  账户权益: "Vrijednost računa",
  "数量/类别": "Količina/Kategorija",
  全部币种: "Sve kriptovalute",
  全部类型: "Sve vrste",
  账单信息: "Informacije o računu",
  理财赎回: "Otkup financijskog proizvoda",
  购买理财: "Kupnja financijskog proizvoda",
  收入: "Prihodi",
  支出: "Rashodi",
  到: "na",
  资产划转: "Prijenos imovine",
  "最少*": "Minimalno *",
  "可用资产：": "Raspoloživa imovina:",
  确认划转: "Potvrdi prijenos",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Morate prenijeti imovinu na odgovarajući račun kako biste mogli trgovati. Prijenosi između računa su besplatni.",
  币种账户选择: "Odabir računa kriptovalute",
  选择账户: "Odabir računa",
  划转详情: "Detalji prijenosa",
  划转明细: "Specifikacije prijenosa",
  收入账单: "Račun prihoda",
  支出账单: "Račun rashoda",
  金额: "Iznos",
  总收益: "Ukupni prinos",
  佣金: "Provizija",
  用户名: "Korisničko ime",
  "已领取：": "Preuzeto:",
  "未领取：": "Nije preuzeto:",
  "请选择国家/地区": "Odaberite državu/regiju",
  请上传身份信息: "Prenesite podatke o identitetu",
  请选择证件类型: "Odaberite vrstu dokumenta",
  请填写证件编码: "Unesite broj dokumenta",
  请填写名字: "Unesite ime",
  请填写姓氏: "Unesite prezime",
  投资金额: "Iznos ulaganja",
  天: "dana",
  请输入手机号: "Unesite broj mobitela",
  搜索: "Pretraži",
  搜索历史: "Povijest pretraživanja",
  热门推荐: "Popularne preporuke",
  "《Xspace Earn协议》": "Xspace Earn Protokol",
  我已了解并同意: "Razumijem i prihvaćam",
  协议: "Protokol",
  Xspace官方中文交流群: "Xspace službena kineska zajednica",
  Xspace官方英文交流群: "Xspace službena engleska zajednica",
  预计维护至: "Predviđeno održavanje do",
  更多功能: "Više funkcija",
  下载APP: "Preuzmi aplikaciju",
  理财: "Financijski proizvod",
  推荐: "Preporučeno",
  Telegram官方中文频道: "Službeni Telegram kanal (kineski)",
  Telegram官方英文频道: "Službeni Telegram kanal (engleski)",
  官方邮箱: "Službena e-adresa",
  客服邮箱: "E-adresa korisničke podrške",
  上述信息最终解释权归官方所有:
    "Gore navedene informacije podliježu službenom tumačenju platforme.",
  IOS版下载: "Preuzmi za iOS",
  Android版下载: "Preuzmi za Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Naknada za transakciju = Naknada za kupnju + Stopa financiranja + Naknada za prodaju",
  资金划转: "Prijenos sredstava",
  止盈: "Ograničenje dobiti",
  止损: "Zaustavljanje gubitka",
  自动平仓: "Automatsko zatvaranje",
  委托挂单: "Otvoreni nalog",
  买: "Kupi",
  卖: "Prodaj",
  "买入/做多": "Kupi/Long",
  "卖出/做空": "Prodaj/Short",
  详情: "Detalji",
  浮动涨跌: "Nerealizirana dobit/gubitak",
  最小: "Minimalno",
  充币数量: "Količina za uplatu",
  请输入充币数量: "Unesite količinu za uplatu",
  支付截图: "Dokaz o plaćanju",
  提交: "Pošalji",
  上传驾驶证: "Prijenos vozačke dozvole",
  上传护照: "Prijenos putovnice",
  加载中: "Učitavanje...",
  上传成功: "Uspješan prijenos",
  充值历史: "Povijest uplata",
  合约卖出手续费: "Naknada za prodaju terminskih ugovora",
  合约买入手续费: "Naknada za kupnju terminskih ugovora",
  系统加款: "Sistemsko odobrenje",
  系统减款: "Sistemsko terećenje",
  合约资金费率: "Stopa financiranja terminskih ugovora",
  佣金分成: "Podjela provizije",
  U本位合约: "Terminski ugovori s marginom u USDT",
  资产管理: "Upravljanje imovinom",
  APP下载: "Preuzmi aplikaciju",
  全球领先的数字理财平台:
    "Vodeća svjetska platforma za digitalno upravljanje imovinom",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Trgujte odmah Bitcoinom, Ethereumom i stotinama drugih digitalnih sredstava",
  "24H涨跌幅": "Promjena 24h",
  查看更多行情: "Pogledajte više tržišta",
  近24小时成交量: "Volumen 24h",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Nudi stotine spot i terminskih parova. Više od 20 milijuna korisnika u 200+ zemalja. Vodeća svjetska platforma za digitalnu imovinu.",
  用户国家分布: "Korisnici po državama",
  用户数: "Broj korisnika",
  交易对: "Parovi za trgovanje",
  服务支持: "Podrška",
  "随时随地，多平台终端交易": "Trgujte bilo gdje s višeplatformskom podrškom",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Kompatibilan s više uređaja za sve potrebe trgovanja.",
  随时查看实时行情: "Pogledajte cijene u stvarnom vremenu bilo gdje",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Jednostavno kupujte i prodajte BTC, ETH, DOGE i drugu digitalnu imovinu",
  获取您关注的加密货币价格变化预警:
    "Primajte upozorenja o cijenama za kriptovalute koje pratite",
  "查看比特币现货、期货、期权价格":
    "Pogledajte cijene Bitcoin spota, terminskih ugovora i opcija",
  比较各交易所加密货币价格:
    "Usporedite cijene kriptovaluta na različitim burzama",
  开启您的数字货币之旅: "Započnite svoje putovanje s digitalnom imovinom",
  快捷购买数字货币: "Brzo kupite kriptovalute",
  "使用多种支付方式交易数字货币，安全快捷":
    "Trgujte sigurno i brzo s više načina plaćanja",
  最优的交易费率: "Najbolje naknade za transakcije",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Povoljne stope, konkurentne VIP pogodnosti i usluga vrhunske kvalitete.",
  可信赖的安全保障: "Pouzdana sigurnost",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Napredne sigurnosne mjere i SAFU fond štite vašu imovinu od rizika.",
  交易: "Trgovanje",
  币币市场: "Spot tržište",
  "24H成交量": "Volumen 24h",
  交易所: "Burza",
  "24H最高": "Najviša 24h",
  "24H最低": "Najniža 24h",
  永续合约: "Perpetualni terminski ugovori",
  日涨跌: "Dnevna promjena",
  交易深度: "Dubina knjige naloga",
  "资产(合约)": "Imovina (Terminski ugovori)",
  历史仓位: "Povijest pozicija",
  兑换记录: "Povijest zamjena",
  类型: "Vrsta",
  充值记录: "Povijest uplata",
  划转记录: "Povijest prijenosa",
  类别: "Kategorija",
  历史账单: "Povijest računa",
  在线充值: "Online uplata",
  安全设置: "Sigurnosne postavke",
  用于账户登录使用: "Koristi se za prijavu na račun",
  用户提现时安全验证使用: "Koristi se za sigurnosnu provjeru prilikom isplata",
  验证: "Verificiraj",
  万: "milijun",
  随时随地开启交易: "Započnite trgovanje bilo gdje",
  "*货币交易所的所有功能尽在你的手中。": "Sve funkcije burze * u vašoj ruci.",
  "下载*货币交易所APP。": "Preuzmite aplikaciju burze *.",
  下载自: "Preuzmi s",
  内测版: "Beta verzija",
  下载: "Preuzmi",
  扫码下载: "Skeniraj za preuzimanje",
  设置您的资产密码: "Postavite svoju lozinku za imovinu",
  法币: "Fiat",
  我要买: "Želim kupiti",
  我要卖: "Želim prodati",
  请输入金额: "Unesite iznos",
  汇率: "Tečaj",
  获得: "Dobij",
  支付通道: "Kanal plaćanja",
  收款通道: "Kanal za primanje",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Prilikom prodaje provjerite da je kanal za primanje na vaše ime.",
  当前法币暂不支持交易对可尝试前往提现:
    "Ovaj fiat par trenutno nije podržan. Pokušajte isplatu.",
  前往提现: "Idi na isplatu",
  该法币暂无通道: "Nema dostupnog kanala za ovu fiat valutu",
  "正在出售中，请耐心等待": "Prodaja je u tijeku, molimo pričekajte",
  请选择支付通道: "Odaberite kanal plaćanja",
  请选择方式: "Odaberite metodu",
  法币历史: "Povijest fiat transakcija",
  买币: "Kupi kriptovalutu",
  卖币: "Prodaj kriptovalutu",
  失败: "Neuspješno",
  已完成: "Dovršeno",
  未付款: "Neplaćeno",
  待审核: "Na čekanju",
  打款中: "Isplata u tijeku",
  订单详情: "Detalji narudžbe",
  联系客服: "Kontaktirajte podršku",
  到账金额: "Primljeni iznos",
  通道: "Kanal",
  收款人: "Primatelj",
  收款账户: "Račun primatelja",
  "订单出售失败，请查下方失败原因":
    "Prodaja narudžbe neuspješna. Pogledajte razlog u nastavku.",
  失败原因: "Razlog neuspjeha",
  您还未进行付款: "Još niste izvršili plaćanje",
  您已成功购买: "Kupnja je uspješna",
  已取消订单: "Narudžba otkazana",
  "订单正在审核中，请耐心等待": "Narudžba se obrađuje. Molimo pričekajte.",
  您已成功出售: "Prodaja je uspješna",
  "订单正在打款中，请耐心等待": "Isplata je u tijeku. Molimo pričekajte.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Za plaćanje morate posjetiti drugu platformu. Pazite na sigurnost svojih podataka.",
  当前法币暂不支持交易对可尝试前往充值:
    "Ovaj fiat par trenutno nije podržan. Pokušajte uplatu.",
  前往充值: "Idi na uplatu",
  购买: "Kupi",
  订单号: "Broj narudžbe",
  单价: "Jedinična cijena",
  到账数量: "Primljena količina",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Postoji neplaćena narudžba. Želite li pokrenuti novi nalog za plaćanje?",
  继续支付: "Nastavi plaćanje",
  重新下单: "Nova narudžba",
  是否确定出售: "Jeste li sigurni da želite prodati?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Nakon potvrde, platforma će dodijeliti kupca. Pričekajte spajanje.",
  出售: "Prodaj",
  收款方式: "Način primanja",
  订单已生成: "Narudžba je generirana",
  取消订单: "Otkaži narudžbu",
  请在: "Molimo unutar",
  内完成付款: "izvršite plaćanje",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Napustite platformu, prijavite se na svoj odabrani način plaćanja i prenesite iznos na sljedeći račun prodavatelja. Obavezno navedite referencu:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Bez reference, prodavatelj neće moći potvrditi plaćanje, što može dovesti do gubitka imovine.",
  "未在规定的时间内付款，订单都将被取消。":
    "Ako ne platite unutar zadanog vremena, narudžba će biti otkazana.",
  姓名: "Ime i prezime",
  收款姓名: "Ime primatelja",
  开户支行: "Podružnica banke",
  银行卡号: "Broj bankovne kartice",
  "付款后，返回本平台": "Nakon plaćanja, vratite se na ovu platformu",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Obavezno kliknite gumb 'Izvršio sam plaćanje, obavijesti prodavatelja'",
  未点击卖家不会放款:
    "Prodavatelj će pustiti kriptovalutu tek nakon što kliknete gumb",
  交易条款: "Uvjeti transakcije",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Sredstva za kupnju moraju biti legalna i sigurna",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Prijevara, piramidalne sheme, kockanje ili druga ilegalna sredstva nisu dopušteni",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Ako nakon transakcije sredstva budu zamrznuta ili sumnjiva, nećemo pustiti USDT i izvršit ćemo povrat novca",
  "已付款，通知卖家": "Plaćeno, obavijesti prodavatelja",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Ako danas otkažete ukupno * narudžbi, vaše pravo kupnje za danas bit će opozvano. Otkazati ovu narudžbu?",
  添加收款方式: "Dodaj način primanja",
  是否删除此收款方式: "Izbrisati ovaj način primanja?",
  删除: "Izbriši",
  请选择法币: "Odaberite fiat valutu",
  机构名称: "Naziv institucije",
  请选择机构: "Odaberite instituciju",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Vaš odabrani način primanja bit će prikazan kupcima kada prodajete kriptovalutu. Provjerite jesu li podaci točni.",
  请选择银行: "Odaberite banku",
  请输入姓名: "Unesite ime",
  账号: "Broj računa",
  请输入账号: "Unesite broj računa",
  收款码: "Kod za primanje",
  "银行账号/卡号": "Bankovni račun/Broj kartice",
  "请输入银行账号/卡号": "Unesite bankovni račun/broj kartice",
  "开户支行（选填）": "Podružnica banke (opcionalno)",
  请输入开户支行: "Unesite podružnicu banke",
  "加入*官方频道": "Pridružite se službenom kanalu *",
  关于: "O nama",
  条款: "Uvjeti",
  成功: "Uspješno",
  等待: "Čekanje",
  作废: "Nevažeće",
  确认付款: "Potvrdi plaćanje",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Plaćanje dovršeno? Nakon potvrde, prodavatelj će provjeriti primitak unutar * minuta.",
  最大金额: "Maksimalni iznos",
  最小金额: "Minimalni iznos",
  付款: "Plaćanje",
  法币充值: "Uplata fiat valute",
  法币提现: "Isplata fiat valute",
  待支付: "Za platiti",
  已支付: "Plaćeno",
  商户名: "Ime prodavatelja",
  当前没有添加支付方式: "Nije dodan nijedan način plaćanja",
  添加后再出售: "Dodajte jedan prije prodaje",
  新人大礼包: "Paket dobrodošlice",
  注册即可领取: "Primite nakon registracije",
  立即领取: "Preuzmi odmah",
  不再提示: "Ne prikazuj više",
  "该奖励需在APP中领取，请下载APP":
    "Ova se nagrada može preuzeti samo u aplikaciji. Preuzmite aplikaciju.",
  去交易: "Idi na trgovanje",
  期权交易: "Trgovanje opcijama",
  交易额: "Iznos trgovanja",
  可用额度: "Raspoloživi limit",
  交易周期: "Razdoblje trgovanja",
  看涨: "Rast (Call)",
  看跌: "Pad (Put)",
  看空: "Short",
  当前持有: "Trenutna pozicija",
  胜率: "Postotak uspješnosti",
  "盈利/亏损数": "Broj transakcija s dobiti/gubitkom",
  累计实现盈亏: "Realizirana ukupna dobit/gubitak",
  秒: "sekundi",
  分: "minuta",
  小时: "sati",
  周: "tjedan",
  下单时间: "Vrijeme narudžbe",
  剩余时间: "Preostalo vrijeme",
  买入价: "Kupovna cijena",
  结算价: "Cijena poravnanja",
  实现盈利: "Realizirana dobit",
  结算时间: "Vrijeme poravnanja",
  期权: "Opcija",
  新手教程: "Vodič za početnike",
  我的订单: "Moje narudžbe",
  赔率: "Tečaj",
  全部订单: "Sve narudžbe",
  持有订单: "Otvorene narudžbe",
  历史订单: "Povijest narudžbi",
  输入交易额度: "Unesite iznos trgovanja",
  选择交易周期: "Odaberite razdoblje trgovanja",
  去注册: "Registracija",
  冻结: "Zamrzni",
  期权支出: "Trošak opcije",
  期权收入: "Prihod od opcije",
  用户提现: "Isplata korisnika",
  "是否购买？": "Kupiti ovu opciju?",
  购买成功: "Uspješna kupnja",
  请签名: "Molimo potpišite",
  提交签名: "Pošalji potpis",
  清空签名: "Očisti potpis",
  签名审核中: "Potpis je u provjeri",
  已提交: "Poslano",
  扫一扫下载APP: "Skenirajte za preuzimanje aplikacije",
  新手领取大礼包: "Paket dobrodošlice za nove korisnike",
  注册实名即送彩金: "Registrirajte se i verificirajte za bonus",
  交易总额: "Ukupni volumen trgovanja",
  资产不足: "Nedovoljno imovine",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Nedovoljno imovine na WIN računu. Možete prenijeti imovinu sa svog glavnog računa.",
  Win: "WIN",
  比赛: "Natjecanje",
  未开始: "Nije započelo",
  赛程: "Raspored",
  赛果: "Rezultat",
  已结束: "Završeno",
  让球: "Handicap",
  进球数: "Golovi",
  大: "Više (Over)",
  小: "Manje (Under)",
  胜负平: "1X2 (Pobjeda/Neriješeno/Poraz)",
  和局: "Neriješeno",
  投注: "Ulog",
  下注金额: "Iznos uloga",
  下注: "Stavi ulog",
  阵容: "Sastav",
  分析: "Analiza",
  输入下注金额: "Unesite iznos uloga",
  下注成功: "Uspješno stavljen ulog",
  投注记录: "Povijest uloga",
  未结算: "Nije poravnato",
  已结算: "Poravnato",
  流水: "Volumen",
  输赢: "Dobit/Gubitak",
  赛时: "Vrijeme utakmice",
  下注时间: "Vrijeme ulaganja",
  足彩竞猜: "Nogometno klađenje",
  查看详情: "Pogledaj detalje",
  输: "Gubitak",
  赢: "Dobit",
  主: "Domaćin",
  客: "Gost",
  主胜: "Pobjeda domaćina",
  客胜: "Pobjeda gosta",
  平: "Neriješeno",
  已延期: "Odgođeno",
  账号异常: "Anomalija računa",
  全场独赢: "1X2 cijela utakmica",
  全场让球: "Handicap cijela utakmica",
  全场大小: "Više/Manje cijela utakmica",
  总进球: "Ukupno golova",
  拍摄照片要求: "Zahtjevi za fotografiju",
  标准拍摄: "Standardna fotografija",
  边框缺失: "Rub nedostaje",
  照片模糊: "Mutna fotografija",
  闪光强烈: "Prejako bljeskanje",
  上传手持证件照: "Prijenos fotografije s dokumentom u ruci",
  上传证件照: "Prijenos fotografije dokumenta",
  换一张: "Nova fotografija",
  出生日期: "Datum rođenja",
  请选择出生日期: "Odaberite datum rođenja",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Unesite donji verifikacijski kod za dobivanje koda e-poštom za registraciju.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Još imate * pokušaja verifikacije. Nakon tog ograničenja nećete se moći verificirati.",
  上半场: "1. poluvrijeme",
  下半场: "2. poluvrijeme",
  独赢: "1X2",
  上半场独赢: "1. poluvrijeme 1X2",
  下半场独赢: "2. poluvrijeme 1X2",
  上半场让球: "1. poluvrijeme Handicap",
  下半场让球: "2. poluvrijeme Handicap",
  上半场大小球: "1. poluvrijeme Više/Manje",
  下半场大小球: "2. poluvrijeme Više/Manje",
  波胆: "Točan rezultat",
  上半场波胆: "1. poluvrijeme Točan rezultat",
  下半场波胆: "2. poluvrijeme Točan rezultat",
  单双: "Nepar/Par",
  单: "Nepar",
  双: "Par",
  上半场单双: "1. poluvrijeme Nepar/Par",
  下半场单双: "2. poluvrijeme Nepar/Par",
  上半场总进球: "1. poluvrijeme Ukupno golova",
  下半场总进球: "2. poluvrijeme Ukupno golova",
  中场: "Poluvrijeme",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Napomena: Za fotografiju s dokumentom u ruci, napišite tekst na bijeli papir i fotografirajte ga zajedno sa svojim dokumentom, kao na primjeru.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Nedavno je kažnjeno mnogo prijevarnih računa. Kontaktirajte podršku ako smatrate da je vaš račun nepravedno kažnjen.",
  最小下注金额: "Minimalni ulog",
  参与活动最小下注金额: "Minimalni ulog za sudjelovanje u aktivnosti",
  记住密码: "Zapamti lozinku",
  比分: "Rezultat",
  "您还未登录，请先登录": "Niste prijavljeni. Prvo se prijavite.",
  立即登录: "Prijavi se odmah",
  下注限额: "Ograničenje uloga",
  可赢金额: "Iznos koji se može dobiti",
  闪兑详情: "Detalji brze zamjene",
  大小球: "Više/Manje",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Zbog fluktuacija tečaja, konačni iznos uloga može se razlikovati. Narudžba je mjerodavna.",
  开赛时间: "Vrijeme početka",
  足球收入: "Prihodi od nogometa",
  足球支出: "Rashodi za nogomet",
  活动详情: "Detalji aktivnosti",
  为世界杯喝彩: "Podržite Svjetsko prvenstvo",
  我的竞猜: "Moja nagađanja",
  "竞猜比赛、有机会瓜分*USDT": "Nagađajte utakmice i osvojite dio * USDT",
  "瓜分*USDT": "Podijelite * USDT",
  距离活动结束还有: "Do kraja aktivnosti:",
  我的门票: "Moje ulaznice",
  竞猜结束时间: "Kraj nagađanja",
  猜比分: "Nagađaj rezultat",
  "福利派送中，完成任务即可获取门票":
    "Bonusi se dijele. Dovršite zadatke za zaradu ulaznica.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Dovršite sljedeće zadatke za odgovarajući broj ulaznica za sudjelovanje u natjecanju.",
  时: "sat",
  活动: "Aktivnost",
  竞猜记录: "Povijest nagađanja",
  结果: "Rezultat",
  任务: "Zadatak",
  去邀请: "Pozovi",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Nagađajte rezultat svake utakmice i osvojite dio od $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Za nagađanje je potrebna ulaznica. Ulaznice se mogu zaraditi dovršavanjem zadataka platforme.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Nakon uspješnog nagađanja, pošaljite snimku zaslona podršci. Oni će doznačiti bonus na vaš račun koji možete odmah isplatiti.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Prijevara je zabranjena. Ako se otkrije, nagrada će biti poništena.",
  "完成任务后，点击咨询客服获得门票。":
    "Nakon dovršetka zadataka, kliknite 'Kontaktiraj podršku' za dobivanje ulaznica.",
  继续猜: "Nastavi nagađati",
  总单数: "Ukupan broj oklada",
  赛事筛选: "Filtriraj po natjecanju",
  球队筛选: "Filtriraj po timu",
  总金额: "Ukupni iznos",
  总流水: "Ukupni volumen",
  派奖金额: "Iznos dodijeljenog bonusa",
  下注单数: "Broj oklada",
  利润: "Dobit",
  更多福利: "Više bonusa",
  我的奖金: "Moj bonus",
  未认证: "Nije verificirano",
  总量: "Ukupno",
  或: "ili",
  模拟交易: "Demo trgovanje",
  体验账户不可操作: "Nije dostupno na demo računu",
  世界杯比分竞猜: "Nagađanje rezultata SP-a",
  "领*USDT起": "Primite od * USDT",
  消息: "Poruke",
  滚球: "Uživo klađenje",
  是: "Da",
  不是: "Ne",
  当前余额: "Trenutno stanje",
  KOL招募: "Regrutacija KOL-a",
  本月净输赢: "Neto dobit/gubitak ovaj mjesec",
  本月佣金: "Provizija ovaj mjesec",
  佣金比例: "Postotak provizije",
  活跃人数: "Aktivni korisnici",
  新增下级: "Nove niže razine",
  登录人数: "Prijavljeni korisnici",
  首存人数: "Korisnici s prvom uplatom",
  数据分析: "Analiza podataka",
  人数: "Broj osoba",
  新注册存款金额: "Iznos uplate novih registracija",
  老用户存款金额: "Iznos uplate postojećih korisnika",
  首存金额: "Iznos prve uplate",
  快捷入口: "Brzi pristup",
  成员管理: "Upravljanje članovima",
  财务报表: "Financijska izvješća",
  分红报表: "Izvješće o dividendi",
  订单记录: "Povijest narudžbi",
  VIP专享: "VIP ekskluzivno",
  推广工具: "Alati za promociju",
  计算规则: "Pravila izračuna",
  账变明细: "Detalji transakcije",
  成员: "Članovi",
  下级概览: "Pregled nižih razina",
  下级成员总计: "Ukupno nižih razina",
  本月新增: "Novi ovaj mjesec",
  本月活跃会员: "Aktivni članovi ovaj mjesec",
  今日活跃会员: "Aktivni članovi danas",
  本月有效活跃: "Efektivno aktivni ovaj mjesec",
  活跃成员占比: "Postotak aktivnih članova",
  本月活跃: "Aktivni ovaj mjesec",
  今日活跃: "Aktivni danas",
  下级成员: "Niže razine",
  会员账号: "Račun člana",
  统计时间: "Vrijeme statistike",
  筛选: "Filtriraj",
  存款: "Uplata",
  取款: "Isplata",
  总输赢: "Ukupna dobit/gubitak",
  是否有效用户: "Aktivni korisnik?",
  最近登录时间: "Zadnja prijava",
  否: "Ne",
  开始时间: "Vrijeme početka",
  结束时间: "Vrijeme završetka",
  提取: "Isplata",
  总盈亏: "Ukupni rezultat",
  净盈亏: "Neto rezultat",
  分红: "Dividenda",
  概览: "Pregled",
  月度详细数据: "Mjesečni detaljni podaci",
  未发放: "Nije dodijeljeno",
  活跃用户: "Aktivni korisnici",
  有效新增会员: "Efektivni novi članovi",
  冲正后净输赢: "Neto dobit/gubitak nakon korekcije",
  上月结余: "Stanje prethodnog mjeseca",
  净输赢: "Neto dobit/gubitak",
  "系统每日新加坡时间1:00更新一次报表":
    "Izvješća se ažuriraju svakodnevno u 01:00 po singapurskom vremenu.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "U izvješćima, pozitivni brojevi znače dobit za partnera, negativni brojevi znače gubitak za partnera.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Podaci o proviziji ažuriraju se svakodnevno, indikativni su i ne predstavljaju konačnu osnovu za isplatu.",
  选择时间: "Odabir vremena",
  足球: "Nogomet",
  投注金额: "Iznos uloga",
  有效订单: "Valjane narudžbe",
  下级账户: "Račun niže razine",
  待成交: "Na čekanju",
  下单金额: "Iznos narudžbe",
  订单内容: "Sadržaj narudžbe",
  秒数: "Sekunde",
  联赛: "Liga",
  队伍: "Tim",
  比赛时间: "Vrijeme utakmice",
  玩法: "Vrsta oklade",
  等级规则表: "Tablica pravila razina",
  等级: "Razina",
  活跃会员: "Aktivni članovi",
  最新活跃: "Posljednja aktivnost",
  额外佣金: "Dodatna provizija",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Mjesečno na temelju standarda rasta. Možete imati koristi samo od jedne razine.",
  渠道生成: "Generiranje kanala",
  创建: "Stvori",
  渠道名称: "Naziv kanala",
  注册人数: "Broj registracija",
  浏览人数: "Broj pregleda",
  构建状态: "Status izgradnje",
  禁用: "Onemogući",
  启用: "Omogući",
  查看: "Pogledaj",
  创建渠道: "Stvori kanal",
  创建成功: "Uspješno stvoreno",
  操作成功: "Uspješna radnja",
  渠道详情: "Detalji kanala",
  邀请码: "Pozivni kod",
  访问人数: "Broj posjetitelja",
  渠道地址: "Adresa kanala",
  我的福利: "Moji bonusi",
  充值福利: "Bonus za uplatu",
  当前流水: "Trenutni volumen",
  如何参与: "Kako sudjelovati",
  币种充值: "Uplata kriptovalute",
  充值福利中领取福利: "Preuzmi bonus u bonusu za uplatu",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Pravilo: Bonus za uplatu je dobrovoljan, vrijedi 24 sata nakon uplate. Nakon preuzimanja, isplata se privremeno blokira dok se ne postigne zahtjev volumena.",
  失效日期: "Datum isteka",
  "暂无福利领取，充值后领取": "Nema dostupnog bonusa. Preuzmite nakon uplate.",
  参与: "Sudjeluj",
  充值赠送: "Bonus za uplatu",
  "领取*%的赠送": "Preuzmi *% bonusa",
  去领取: "Preuzmi",
  VIP奖励: "VIP nagrada",
  "当前可领取*USDT，是否确认领取": "* USDT dostupno za preuzimanje. Potvrditi?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Nakon preuzimanja, isplata se privremeno blokira dok se ne postigne volumen od * USDT.",
  充值送大礼: "Poklon za uplatu",
  "存入越多，送越多！": "Što više uplatite, veći je poklon!",
  无效: "Nevažeće",
  有效: "Važeće",
  总存金额: "Ukupni uplaćeni iznos",
  提示: "Napomena",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Pozitivni brojevi u ukupnoj i neto dobiti/gubitku znače dobit platforme. Dnevni podaci su indikativni.",
  "净盈亏：总盈亏-用户返水":
    "Neto rezultat: Ukupni rezultat - Povrat novca korisniku",
  盈利方: "Strana s dobiti",
  代理: "Agent",
  客户: "Klijent",
  平局: "Neriješeno",
  平台: "Platforma",
  "已提交审核，请耐心等待": "Poslano na provjeru. Molimo pričekajte.",
  充值日期: "Datum uplate",
  平台本月总输赢: "Ukupna dobit/gubitak platforme ovaj mjesec",
  KOL招募合作: "Suradnja u regrutaciji KOL-a",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Platforma otvara regrutaciju KOL-a. S računom društvenih medija možete uživati u dividendi i doživotnoj zaradi kroz jednokratnu promociju klijenata.",
  级别: "Razina",
  平台利润返佣: "Provizija na dobit platforme",
  佣金案例: "Primjer provizije",
  交易项目: "Proizvodi za trgovanje",
  "期权交易、合约交易、足球游戏":
    "Trgovanje opcijama, trgovanje terminskim ugovorima, nogometne igre",
  报名方式: "Način prijave",
  点击KOL招募报名: "Kliknite za prijavu na regrutaciju KOL-a",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Dobrodošli u naš tim. Podržavamo vas u izgradnji vlastitog korisničkog sustava. Zaradite do *% provizije. Veselimo se vašem sudjelovanju.",
  输入联系方式: "Unesite kontakt podatke",
  最低活跃人数: "Minimalni broj aktivnih korisnika",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Npr.: Ako aktivni korisnici ovaj mjesec ≥ * i ukupna dobit/gubitak platforme ≥ * USDT, pripadate razini * i dobivate *% provizije.",
  比分竞猜: "Nagađanje rezultata",
  豪礼相赠: "Veliki poklon",
  足球活动: "Nogometna aktivnost",
  圣诞节活动: "Božićna aktivnost",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Sudjelovali ste u aktivnosti. Isplata je privremeno blokirana. Potrebno vam je još * USDT volumena za deblokiranje.",
  剩余流水: "Preostali volumen",
  助力足球: "Podrška nogometu",
  佣金累计: "Ukupna provizija",
  有效投注: "Valjani ulozi",
  今日: "Danas",
  今日返水: "Povrat novca danas",
  VIP返水: "VIP povrat novca",
  返水记录: "Povijest povrata novca",
  成员信息: "Informacije o članu",
  基本信息: "Osnovne informacije",
  钱包余额: "Stanje novčanika",
  投注信息: "Informacije o ulogu",
  返水: "Povrat novca",
  总下注: "Ukupni ulog",
  今日输赢: "Dobit/Gubitak danas",
  下注动态: "Aktivnost klađenja",
  返水奖励: "Nagrada za povrat novca",
  分红金额: "Iznos dividende",
  返水支出: "Trošak povrata novca",
  总返水: "Ukupni povrat novca",
  流水总额: "Ukupni volumen",
  返水总额: "Ukupni povrat novca",
  返水详情: "Detalji povrata novca",
  日流水: "Dnevni volumen",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platforma daje dodatni povrat novca na temelju dnevnog volumena vaših nižih razina. Isplata svakodnevno u 00:00 po singapurskom vremenu na račun za nagrade.",
  "申请成功，等待审核": "Zahtjev uspješan, čekanje na provjeru",
  "我出本金，盈利共分享": "Ja dajem kapital, dobit se dijeli",
  最高分红: "Maksimalna dividenda",
  投资大师比赛: "Natjecanje Majstor investitor",
  "我出本金，你盈利": "Ja dajem kapital, ti zarađuješ",
  共分享: "Zajedničko dijeljenje",
  最高分红可得: "Maksimalna moguća dividenda",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Ekskluzivni bonus dobrodošlice: $* besplatno. Nakon preuzimanja, možete ulagati u bilo koji projekt. Dobit je odmah isplativa.",
  报名领取: "Prijavi se i preuzmi",
  审核驳回: "Provjera odbijena",
  驳回原因: "Razlog odbijanja",
  活动运行周期: "Razdoblje aktivnosti",
  "申请成功后起至*天内完成超额收益。":
    "Ostvarite prekomjerni prinos unutar * dana od odobrenja.",
  分红比: "Omjer dividende",
  "*日获得盈利后，可获得*%的收益额。":
    "Nakon ostvarivanja dobiti na dan *, dobivate *% iznosa prinosa.",
  参与条件: "Uvjeti sudjelovanja",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Korisnici iz Rusije ili Turske koji još nisu sudjelovali.",
  计算项目: "Izračunati proizvodi",
  "合约、体育、期权": "Terminski ugovori, Sport, Opcije",
  我的投资: "Moja ulaganja",
  参与天数: "Dani sudjelovanja",
  累计下注: "Ukupni ulog",
  累计盈亏: "Ukupna dobit/gubitak",
  预计可分红: "Očekivana dividenda",
  常见问题: "Česta pitanja (FAQ)",
  什么是平台出资: "Što je financiranje platforme?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Platforma daje besplatna sredstva korisnicima iz određenih zemalja za ulaganje u projekte.",
  怎么获取平台出资的福利: "Kako dobiti bonus financiranja platforme?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Ako ste iz jedne od određenih zemalja, kliknite gumb za prijavu. Nakon odobrenja, * USDT bit će prebačeno na vaš račun za nagrade, koji možete prenijeti za ulaganje.",
  什么是分红: "Što je dividenda?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividenda: Ako unutar zadanog vremena prinos dosegne 100%, dobivate 50% prekomjernog prinosa. Npr.: Primite 100 USDT, ostvarite 120% prinosa, tada je 20% prekomjerno.",
  "如何取得分红？": "Kako dobiti dividendu?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Ciklus aktivnosti je svakih * dana. Nakon završetka, vrši se obračun. Ako ispunjavate zahtjeve, dividenda se šalje na račun za nagrade. Ako ne ispunjavate, vaš prinos i financiranje platforme bit će uklonjeni.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Računi koji sudjeluju moraju biti verificirani KYC-om. Samo jedan bonus po računu.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC za sudjelovanje vrijedi samo za određene zemlje. Provjerite odgovara li vaša zemlja zemlji aktivnosti.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Nakon uspješnog sudjelovanja, isplata se privremeno blokira do završetka aktivnosti.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Poštujte pravila aktivnosti. U slučaju prijevare ili zlouporabe sistemskih grešaka, sva sredstva na vašem računu bit će trajno zamrznuta.",
  平台出资: "Financiranje platforme",
  平台出资收回: "Povučeno financiranje platforme",
  投资大师奖励: "Nagrada Majstor investitor",
  请下载APP添加收款方式: "Preuzmite aplikaciju za dodavanje načina primanja",
  请下载APP进行身份验证: "Preuzmite aplikaciju za verifikaciju identiteta",
  请下载APP参与: "Preuzmite aplikaciju za sudjelovanje",
  技术指标: "Tehnički indikatori",
  主图: "Glavni grafikon",
  副图: "Sporedni grafikon",
  新注册人数: "Nove registracije",
  老用户存款人数: "Postojeći korisnici koji uplaćuju",
  存款人数: "Broj uplata",
  取款人数: "Broj isplata",
  投注人数: "Broj oklada",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Isključujući korisnike iz Indonezije, Indije, Bangladeša koji još nisu sudjelovali.",
  市场动态: "Dinamika tržišta",
  外汇合约: "Forex terminski ugovori",
  盈亏比: "Omjer dobiti/gubitka",
  委托价: "Cijena naloga",
  可用余额: "Raspoloživo stanje",
  持仓额: "Vrijednost pozicije",
  强平价: "Cijena likvidacije",
  修改: "Izmijeni",
  修改价位: "Izmijeni cijenu",
  外汇: "Forex",
  外汇账户: "Forex račun",
  我的交易: "Moje transakcije",
  未设置: "Nije postavljeno",
  超出最大可设数值: "Premašuje maksimalnu podesivu vrijednost",
  超出最小可设数值: "Ispod minimalne podesive vrijednosti",
  止盈超出最小可设数值:
    "Ograničenje dobiti ispod minimalne podesive vrijednosti",
  止损超出最大可设数值:
    "Zaustavljanje gubitka premašuje maksimalnu podesivu vrijednost",
  止盈超出最大可设数值:
    "Ograničenje dobiti premašuje maksimalnu podesivu vrijednost",
  止损超出最小可设数值:
    "Zaustavljanje gubitka ispod minimalne podesive vrijednosti",
  挖矿: "Rudarenje",
  交易账户: "Račun za trgovanje",
  买涨: "Kupi (Long)",
  买跌: "Prodaj (Short)",
  请输入正确的银行卡信息: "Unesite ispravne podatke bankovne kartice",
  联系在线客服: "Kontaktirajte podršku uživo",
  法币交易请联系在线客服: "Kontaktirajte podršku za fiat trgovanje",
  提交订单: "Pošalji narudžbu",
  "支付过程如有疑问,请联系在线客服":
    "Kontaktirajte podršku za pitanja o postupku plaćanja",
  彩金赠送: "Dodjela bonusa",
  在线客服: "Podrška uživo",
  最少投资: "Minimalno ulaganje",
  "提交时间:": "Vrijeme slanja:",
  提现拒绝: "Isplata odbijena",
  认证拒绝: "Verifikacija odbijena",
  认证通过: "Verifikacija prihvaćena",
  请输入正确的交易额度: "Unesite valjani iznos trgovanja",
  最大下注金额: "Maksimalni ulog",
  手机号: "Broj mobitela",
  邮箱注册: "Registracija e-poštom",
  手机号注册: "Registracija putem mobitela",
  查询: "Pretraži",
  手机号登录: "Prijava putem mobitela",
  邮箱登录: "Prijava e-poštom",
  请输入数量: "Unesite količinu",
  可用数量: "Raspoloživa količina",
  钱包登录: "Prijava putem novčanika",
  请输入正确的邀请码: "Unesite valjani pozivni kod",
  "请输入邀请码(必填)": "Unesite pozivni kod (obavezno)",
  输入正确的金额: "Unesite valjani iznos",
  法币充值: "Uplata fiat valute",
  卢比充值: "Uplata indijske rupije",
  请输入法币: "Unesite fiat iznos",
  请输入IFSC: "Unesite IFSC kod",
  "银行编码(选填)": "Bankovni kod (opcionalno)",
  请输入银行编码: "Unesite bankovni kod",
  请输入大于8位数的密码: "Unesite lozinku s više od 8 znakova",
  添加成功: "Uspješno dodano",
  "60秒": "60 sekundi",
  "180秒": "180 sekundi",
  "300秒": "300 sekundi",
  "2次密码不一致": "Lozinke se ne podudaraju",
  输入提币数量: "Unesite količinu za isplatu",
  图片格式不正确: "Nevažeći format slike",
  图片大于20M: "Slika je veća od 20 MB",
  请设置委托价格: "Postavite cijenu naloga",
  输入资金密码: "Unesite lozinku za imovinu",
  验证码错误: "Netočan verifikacijski kod",
  充值拒绝: "Uplata odbijena",
  请输入SSN: "Unesite SSN",
  结算完成: "Poravnanje dovršeno",
  继续下单: "Nastavi s narudžbom",
  限价: "Limitirani nalog",
  买入价格: "Kupovna cijena",
  买入量: "Količina za kupnju",
  卖出价格: "Prodajna cijena",
  卖出量: "Količina za prodaju",
  买入: "Kupi",
  卖出: "Prodaj",
  订单创建成功: "Narudžba uspješno stvorena",
  币币买入支出: "Trošak spot kupnje",
  币币买入支出退还: "Povrat troška spot kupnje",
  币币买入获得: "Dobit od spot kupnje",
  币币卖出支出: "Trošak spot prodaje",
  币币卖出支出退还: "Povrat troška spot prodaje",
  币币卖出获得: "Dobit od spot prodaje",
  币币交易手续费: "Naknada za spot transakciju",
  请输入限价: "Unesite ograničenu cijenu",
  成交: "Izvršeno",
  等待成交: "Čeka se izvršenje",
  交易完成: "Transakcija dovršena",
  被取消: "Otkazano",
  交易时间: "Vrijeme transakcije",
  法币交易: "Fiat transakcija",
  法币出售: "Fiat prodaja",

  两次密码不一致: "Lozinke se ne podudaraju",
  再次输入账户密码: "Ponovno unesite lozinku računa",

  美国: "Sjedinjene Američke Države",
  韩国: "Južna Koreja",
  阿尔巴尼亚: "Albanija",
  津巴布韦: "Zimbabve",
  赞比亚: "Zambija",
  也门: "Jemen",
  美属维尔京群岛: "Američki Djevičanski Otoci",
  英属处女群岛: "Britanski Djevičanski Otoci",
  越南: "Vijetnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Urugvaj",
  英国: "Ujedinjeno Kraljevstvo",
  阿拉伯联合酋长国: "Ujedinjeni Arapski Emirati",
  乌克兰: "Ukrajina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Otoci Turks i Caicos",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turska",
  突尼斯: "Tunis",
  特立尼达和多巴哥: "Trinidad i Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Istočni Timor",
  泰国: "Tajland",
  坦桑尼亚: "Tanzanija",
  塔吉克斯坦: "Tadžikistan",
  中国台湾: "Tajvan",
  叙利亚: "Sirija",
  瑞士: "Švicarska",
  瑞典: "Švedska",
  斯威士兰: "Esvatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Šri Lanka",
  西班牙: "Španjolska",
  南非: "Južnoafrička Republika",
  索马里: "Somalija",
  所罗门群岛: "Salomonski Otoci",
  斯洛文尼亚: "Slovenija",
  斯洛伐克: "Slovačka",
  "圣马丁岛（荷兰部分）": "Sveti Martin (nizozemski dio)",
  新加坡: "Singapur",
  塞拉利昂: "Sijera Leone",
  塞舌尔: "Sejšeli",
  塞尔维亚: "Srbija",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saudijska Arabija",
  圣多美和普林西比: "Sveti Toma i Princip",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Sveti Kristofor i Nevis",
  圣文森特和格林纳丁斯: "Sveti Vincent i Grenadini",
  圣彼埃尔和密克隆岛: "Sveti Petar i Mikelon",
  圣露西亚: "Sveta Lucija",
  圣基茨和尼维斯: "Sveti Kristofor i Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Rusija",
  罗马尼亚: "Rumunjska",
  留尼汪: "Réunion",
  刚果共和国: "Republika Kongo",
  卡塔尔: "Katar",
  波多黎各: "Portoriko",
  葡萄牙: "Portugal",
  波兰: "Poljska",
  菲律宾: "Filipini",
  秘鲁: "Peru",
  巴拉圭: "Paragvaj",
  巴布亚新几内亚: "Papua Nova Gvineja",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norveška",
  尼日利亚: "Nigerija",
  尼日尔: "Niger",
  尼加拉瓜: "Nikaragva",
  新西兰: "Novi Zeland",
  新喀里多尼亚: "Nova Kaledonija",
  荷属安德列斯群岛: "Nizozemski Antili",
  荷兰: "Nizozemska",
  尼泊尔: "Nepal",
  纳米比亚: "Namibija",
  缅甸: "Mjanmar",
  莫桑比克: "Mozambik",
  摩洛哥: "Maroko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Crna Gora",
  蒙古: "Mongolija",
  摩纳哥: "Monako",
  摩尔多瓦: "Moldavija",
  墨西哥: "Meksiko",
  马约特: "Mayotte",
  毛里求斯: "Mauricijus",
  毛里塔尼亚: "Mauritanija",
  马里亚纳群岛: "Marijanski Otoci",
  马提尼克: "Martinik",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldivi",
  马来西亚: "Malezija",
  马拉维: "Malavi",
  马达加斯加: "Madagaskar",
  马其顿: "Sjeverna Makedonija",
  中国澳门: "Makao",
  卢森堡: "Luksemburg",
  立陶宛: "Litva",
  列支敦士登: "Lihtenštajn",
  利比亚: "Libija",
  利比里亚: "Liberija",
  莱索托: "Lesoto",
  黎巴嫩: "Libanon",
  拉脱维亚: "Latvija",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgistan",
  科威特: "Kuvajt",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenija",
  哈萨克斯坦: "Kazahstan",
  约旦: "Jordan",
  日本: "Japan",
  牙买加: "Jamajka",
  象牙海岸: "Obala Bjelokosti",
  意大利: "Italija",
  以色列: "Izrael",
  爱尔兰: "Irska",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonezija",
  印度: "Indija",
  冰岛: "Island",
  匈牙利: "Mađarska",
  中国香港: "Hong Kong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Gvajana",
  几内亚比绍共和国: "Gvineja Bisau",
  几内亚: "Gvineja",
  危地马拉: "Gvatemala",
  关岛: "Guam",
  瓜德罗普岛: "Gvadalupa",
  格林纳达: "Grenada",
  格陵兰岛: "Grenland",
  希腊: "Grčka",
  直布罗陀: "Gibraltar",
  加纳: "Gana",
  德国: "Njemačka",
  格鲁吉亚: "Gruzija",
  冈比亚: "Gambija",
  加蓬: "Gabon",
  法属波利尼西亚: "Francuska Polinezija",
  法属圭亚那: "Francuska Gvajana",
  法国: "Francuska",
  芬兰: "Finska",
  斐济: "Fidži",
  法罗群岛: "Farski Otoci",
  埃塞俄比亚: "Etiopija",
  爱沙尼亚: "Estonija",
  厄立特里亚: "Eritreja",
  赤道几内亚: "Ekvatorska Gvineja",
  萨尔瓦多: "Salvador",
  埃及: "Egipat",
  厄瓜多尔: "Ekvador",
  多米尼加共和国: "Dominikanska Republika",
  多米尼加: "Dominika",
  吉布提: "Džibuti",
  丹麦: "Danska",
  捷克: "Češka",
  塞浦路斯: "Cipar",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Hrvatska",
  哥斯达黎加: "Kostarika",
  科特迪瓦: "Obala Bjelokosti",
  库克群岛: "Cookovi Otoci",
  科摩罗: "Komori",
  哥伦比亚: "Kolumbija",
  智利: "Čile",
  乍得: "Čad",
  中非共和国: "Srednjoafrička Republika",
  佛得角: "Zelenortska Republika",
  开曼群岛: "Kajmanski Otoci",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodža",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bugarska",
  文莱: "Brunej",
  巴西: "Brazil",
  博茨瓦纳: "Bocvana",
  波斯尼亚和黑塞哥维那: "Bosna i Hercegovina",
  玻利维亚: "Bolivija",
  不丹: "Butan",
  百慕大群岛: "Bermudi",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgija",
  白俄罗斯: "Bjelorusija",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladeš",
  巴林: "Bahrein",
  巴哈马: "Bahami",
  阿塞拜疆: "Azerbajdžan",
  奥地利: "Austrija",
  澳大利亚: "Australija",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenija",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigva i Barbuda",
  安圭拉: "Angvila",
  安哥拉: "Angola",
  安道尔: "Andora",
  美属萨摩亚: "Američka Samoa",
  阿尔及利亚: "Alžir",
  中国: "Kina",
  余额不足: "Nedovoljno stanje",
  最低购买: "Minimalna kupnja",
  最高购买: "Maksimalna kupnja",
  下单成功: "Narudžba uspješno poslana",
  平仓成功: "Pozicija uspješno zatvorena",
  请输入正确的平仓数量: "Unesite valjanu količinu za zatvaranje",
  加仓成功: "Uspješno povećanje pozicije",
  请输入正确的加仓金额: "Unesite valjani iznos za povećanje pozicije",
  收藏成功: "Dodano u favorite",
  取消收藏成功: "Uklonjeno iz favorita",
  加密币永续: "Perpetual kriptovalute",
  外汇永续: "Perpetual Forex",
  期权账户: "Račun opcija",
  快捷卖币: "Brza prodaja kriptovalute",

  托管资金: "Sredstva pod upravljanjem",
  托管中: "Pod upravljanjem",
  预计日收益: "Procijenjeni dnevni prinos",
  累计收益: "Ukupni prinos",
  周期: "Rok",
  日收益: "Dnevni prinos",
  限额: "Ograničenje",
  立即托管: "Započni upravljanje odmah",
  "已鎖定 請聯繫客服": "Zaključano. Kontaktirajte podršku.",
  产品列表: "Popis proizvoda",
  规则: "Pravila",
  创建订单: "Stvori narudžbu",
  产品名称: "Naziv proizvoda",
  托管周期: "Razdoblje upravljanja",
  等级限制: "Ograničenje razine",
  托管金额: "Iznos pod upravljanjem",
  限额: "Ograničenje",
  余额: "Stanje",
  购买日: "Datum kupnje",
  起息日: "Početak obračuna kamata",
  派息时间: "Vrijeme isplate kamata",
  每天: "Dnevno",
  计息结束日: "Datum završetka kamata",
  每日收益: "Dnevni prinos",
  预计收益: "Procijenjeni prinos",
  "收益将自动发送至您的余额账户;":
    "Prinos će se automatski slati na stanje vašeg računa;",
  "您的资金没有任何风险;": "Vaša sredstva nisu izložena nikakvom riziku;",
  "365*24小时不断地工作;": "Radi 24/7, 365 dana u godini;",
  托管中: "Pod upravljanjem",
  结束: "Završeno",
  今日收益: "Današnji prinos",
  剩余周期: "Preostali rok",
  进行中: "Aktivno",
  已发放: "Isplaćeno",
  信誉分: "Bodovi reputacije",

  复制成功: "Uspješno kopirano",
  VIP权益: "VIP pogodnosti",
  旧密码: "Stara lozinka",
  请输入旧密码: "Unesite staru lozinku",
  "忘记旧密码请联系客服重置。":
    "Ako ste zaboravili staru lozinku, molimo kontaktirajte korisničku podršku za resetiranje.",
  去升级: "Nadogradi",
  描述: "Opis",
  实际存款金额: "Stvarni iznos depozita",
  升级礼金: "Bonus za nadogradnju",
  隔夜利息: "Prekonoćna kamata (swap)",
  自动结算: "Automatsko poravnanje",
  等级规则: "Pravila razina",
  "WEB3.0币持有数据收益": "Prinos podataka o držanju WEB3.0 kovanica",
  总生产: "Ukupna proizvodnja",
  有效节点: "Aktivni čvorovi",
  参与人: "Sudionici",
  用户收益: "Korisnički prinos",
  "流动性WEB3.0输出": "Izlaz likvidnosti WEB3.0",
  总资产: "Ukupna imovina",

  ETHAI持有数据收益: "Prinos podataka držanja ETHAI",
  AI量化流动性: "AI kvantitativna likvidnost",
  现货买入手续费: "Naknada za kupnju spot",
  现货支出: "Spot rashod",
  现货资金费率: "Spot stopa financiranja",
  现货卖出手续费: "Naknada za prodaju spot",
  现货收入: "Spot prihod",
  外汇合约支出: "Rashod deviznog ugovora",
  外汇合约买入手续费: "Naknada za kupnju deviznog ugovora",
  外汇合约资金费率: "Stopa financiranja deviznog ugovora",
  外汇合约卖出手续费: "Naknada za prodaju deviznog ugovora",
  外汇合约收入: "Prihod od deviznog ugovora",
  理财购买: "Kupnja investicijskog proizvoda",
  VIP理财日收益: "Dnevni prinos VIP investicijskog proizvoda",
  VIP理财隔夜利息: "Prekonoćna kamata VIP investicijskog proizvoda",
  VIP本金返还: "VIP povrat glavnice",
  VIP彩金发放: "VIP isplata bonusa",
  VIP彩金抵扣: "VIP odbitak bonusa",
  隔夜利息: "Prekonoćna kamata",
  设置资产密码: "Postavi lozinku imovine",
  锁仓挖矿: "Zaključano rudarenje",
  一站式理财服务: "Financijske usluge na jednom mjestu",
  产品: "Proizvodi",
  客服中心: "Korisnički centar",
  贷款: "Krediti",
  挖矿赚不停: "Kontinuirana zarada od rudarenja",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Zaključano rudarenje znači povjeravanje USDT (USD:1USDT=1USD) visokoučinkovitim rudarskim uređajima platforme kako bi se ostvario prihod u rudarskom bazenu platforme.",
  产品优势: "Prednosti proizvoda",
  随存随取: "Uplata i isplata u bilo kojem trenutku",
  锁仓周期: "Razdoblje zaključavanja",
  每日下发: "Dnevna isplata",
  随机空投: "Nasumični airdrop",
  "100%资金安全保障": "100% sigurnost sredstava",
  "100%节假日收益不间断": "100% kontinuirani prinosi i tijekom praznika",
  成功锁仓后当天产出: "Prinos počinje isti dan nakon uspješnog zaključavanja",
  关于违约金: "O penalu",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Ako želite povući glavnicu prije isteka roka, naplaćuje se penal. Penal = stopa penala × preostali dani × zaključani iznos.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Primjer: stopa penala za ovaj proizvod je 5%, preostala su 3 dana do isteka, a zaključani iznos je 10000U (USDT/USD). Penal = 5%×3×10000=1500U, a stvarno vraćena glavnica je 15000U-1500U.",
  收益计算: "Izračun prinosa",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Platforma nudi više financijskih proizvoda zaključanog rudarenja. Izračun prinosa je sljedeći, na primjer:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Ako korisnik zaključa 10000U (USDT, USD) i odabere 7-dnevni proizvod s dnevnim prinosom od 0,7%~1,8% zaključanog iznosa, dnevni prinos je sljedeći:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maksimum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Nakon 7 dana može se ostvariti prinos od 490U~1260U. Prinos se isplaćuje svakodnevno, a glavnica se po isteku automatski prebacuje na vaš račun.",
  正在托管的资金: "Sredstva pod upravljanjem",
  签到: "Prijava",
  锁仓订单: "Zaključane narudžbe",
  预计今日收益: "Procijenjeni današnji prihod",
  累计收益: "Ukupni prihod",
  托管中的订单: "Narudžbe u upravljanju",
  单笔最少: "Minimalni iznos po narudžbi",
  单笔最多: "Maksimalni iznos po narudžbi",
  日收益率: "Dnevna stopa prinosa",
  说明: "Opis",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistika se temelji na GMT+8 vremenu<br>2. Dnevni prinos izračunava se na temelju svih obrađenih narudžbi između 00:00–23:59 GMT+8 (lokalno 00:00–23:59)<br>3. Dnevni prinos isplaćuje se sljedeći dan između 00:00–00:10 GMT+8.",
  知道了: "Razumijem",
  锁仓: "Zaključaj",
  派息时间: "Vrijeme isplate",
  每日: "Dnevno",
  托管资金: "Sredstva u upravljanju",
  到期返回: "Povrat po dospijeću",
  提前赎回: "Rani otkup",
  预计收益: "Procijenjeni prihod",
  认购: "Pretplata",
  热门: "Popularno",
  数字货币: "Kriptovalute",
  贵金属: "Plemeniti metali",
  大宗商品: "Roba",
  持仓明细: "Detalji pozicije",
  历史明细: "Povijest",
  当前价: "Trenutna cijena",
  "↑买涨": "↑ Kupnja rasta",
  "↓买跌": "↓ Kupnja pada",
  显示全部: "Prikaži sve",
  买入金额: "Iznos kupnje",
  方向: "Smjer",
  收益: "Dobit",
  预期收益: "Očekivana dobit",
  估用保证金: "Procijenjena marža",
  确认下单: "Potvrdi narudžbu",
  锁定: "Zaključano",
  账户总资产: "Ukupna imovina računa",
  明细: "Detalji",
  今日收益: "Današnji prihod",
  仓位保证金: "Marža pozicije",
  持有仓位: "Otvorene pozicije",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Zaključani iznos = zbroj svih nedovršenih narudžbi zaključanog rudarenja",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistika se temelji na GMT+8 vremenu<br>2. Dnevni prihod izračunava se na temelju svih obrađenih narudžbi između 00:00–23:59 GMT+8 (lokalno 00:00–23:59)",
  充值方式: "Način uplate",
  银行汇款: "Bankovni prijenos",
  "银行汇款请联系客服进行操作!":
    "Molimo kontaktirajte korisničku podršku za bankovni prijenos!",
  提款方式: "Način isplate",
  "银行提款请联系客服进行操作!":
    "Molimo kontaktirajte korisničku podršku za bankovno podizanje!",
  资金明细: "Detalji sredstava",
  提现记录: "Povijest isplata",
  拒绝: "Odbijeno",
  通过: "Odobreno",
  拒绝原因: "Razlog odbijanja",

  消息公告: "Obavijesti",
  订单: "Narudžbe",
  个人中心: "Osobni centar",
  "未到期赎回需支付一定的违约金!":
    "Kod prijevremenog otkupa plaća se ugovorna kazna.",

  请输入区号: "Molimo unesite pozivni broj",
  "请选择国家/地区": "Molimo odaberite državu/regiju",

  今日开盘: "Današnje otvaranje",
  昨日收盘: "Jučerašnje zatvaranje",

  实名认证即送: "Dobijte odmah nakon potvrde identiteta",
  立即认证: "Potvrdi odmah",
  新用户礼包: "Poklon paket za nove korisnike",
  完成新人任务领取: "Dovršite zadatke za nove korisnike kako biste preuzeli",
  认证: "Potvrdi",
  时间周期: "Vremensko razdoblje",
  支付金额: "Iznos plaćanja",
  已平仓: "Zatvoreno",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX paket dobrodošlice za nove korisnike: svaki korisnik može dobiti najviše",
  我已经阅读并同意: "Pročitao/la sam i slažem se s",
  隐私政策: "Pravila privatnosti",

  放弃奖励离开: "Odustani od nagrade i napusti",
  继续注册: "Nastavi registraciju",
  分钟: "Minute",

  "请先勾选隐私政策!": "Molimo vas da prvo provjerite Politiku privatnosti!",

  添加其他到自选: "Dodaj ostale na popis za praćenje",

  充值最高可得: "Nadopuni i dobij do 30.000 $.",

  请输入格式正确的手机号: "Molimo unesite važeći broj mobilnog telefona.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 克罗地亚



// WEBPACK FOOTER //
// ./src/lang/kldy.js